export default {
  SET_APPLICATION_INSTANCES: 'setApplicationInstances',
  SET_FIELD_APPLICATION: 'setFieldApplication',
  SET_SELECTED_APPLICATION_INSTANCE: 'setSelectedApplicationInstance'
}